<app-table
  [tableColumns]="
    [
      {
        key: 'county',
        label: 'models.address.county.label' | translate,
        width: '120px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'municipality',
        label: 'models.address.municipality.label' | translate,
        width: '120px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'place',
        label: 'models.address.place.label' | translate,
        width: '120px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'plz',
        label: 'models.address.plz.abbreviation' | translate,
        width: '80px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'streetName',
        label: 'models.address.streetName.label' | translate,
        width: '150px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'houseNumber',
        label: 'models.address.houseNumber.abbreviation' | translate,
        width: '100px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'houseNumberAddition',
        label: 'models.address.houseNumberAddition.label' | translate,
        width: '115px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'marking',
        label: 'models.address.marking.label' | translate,
        width: '120px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'mevId',
        label: 'models.address.mevId.label' | translate,
        width: '150px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'fundingProgram',
        label: 'models.address.fundingProgram.label' | translate,
        width: '150px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'referenceNumberForFundingProgram',
        label:
          'models.address.referenceNumberForFundingProgram.label' | translate,
        width: '200px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'updatedAt',
        label: 'models.branch.updatedAt.label' | translate,
        width: '180px',
        cellTemplate: dateCellTemplate,
      },
      {
        key: 'parcelNumber',
        label: 'models.address.parcelNumber.label' | translate,
        width: '130px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'markingId',
        label: 'models.address.markingId.label' | translate,
        width: '130px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'parcelIdentifier',
        label: 'models.address.parcelIdentifier.label' | translate,
        width: '180px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'municipalityId',
        label: 'models.address.municipalityId.label' | translate,
        width: '130px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'countyId',
        label: 'models.address.countyId.label' | translate,
        width: '120px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'district',
        label: 'models.address.district.label' | translate,
        width: '150px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'x',
        label: 'models.address.x.label' | translate,
        width: '100px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'y',
        label: 'models.address.y.label' | translate,
        width: '100px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'lat',
        label: 'models.address.lat.label' | translate,
        width: '160px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'lon',
        label: 'models.address.lon.label' | translate,
        width: '160px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'ags',
        label: 'models.address.ags.label' | translate,
        width: '100px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'oewId',
        label: 'models.address.oewId.label' | translate,
        width: '300px',
        cellTemplate: markedCellTemplate,
      },
      {
        key: 'uuId',
        label: 'models.address.uuId.label' | translate,
        width: '160px',
        cellTemplate: markedCellTemplate,
      },

      {
        key: 'numberOfHouseholds',
        label: 'models.address.numberOfHouseholds.oew_name' | translate,
        width: '60px',
      },
      {
        key: 'numberOfCompanies',
        label: 'models.address.numberOfCompanies.oew_name' | translate,
        width: '60px',
      },
      {
        key: 'minimumBandwidthDownload',
        label: 'models.address.minimumBandwidthDownload.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'minimumBandwidthUpload',
        label: 'models.address.minimumBandwidthUpload.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'minimumBandwidthTech',
        label: 'models.address.minimumBandwidthTech.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'addressHomePassed',
        label: 'models.address.addressHomePassed.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'plannedBandwidthDownload',
        label: 'models.address.plannedBandwidthDownload.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'plannedBandwidthUpload',
        label: 'models.address.plannedBandwidthUpload.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'plannedBandwidthTech',
        label: 'models.address.plannedBandwidthTech.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'plannedSupplyNotification',
        label: 'models.address.plannedSupplyNotification.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'difficultAccessLocation',
        label: 'models.address.difficultAccessLocation.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'addressIndustrialArea',
        label: 'models.address.addressIndustrialArea.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'plannedCompletion',
        label: 'models.address.plannedCompletion.oew_name' | translate,
        width: '120px',
        cellTemplate: dateCellTemplate,
      },
      {
        key: 'plannedObtainingRightOfWay',
        label: 'models.address.plannedObtainingRightOfWay.oew_name' | translate,
        width: '120px',
        cellTemplate: dateCellTemplate,
      },
      {
        key: 'telecommunicationCompany',
        label: 'models.address.telecommunicationCompany.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'socioEconomicFocusHospital',
        label: 'models.address.socioEconomicFocusHospital.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'socioEconomicFocusSchool',
        label: 'models.address.socioEconomicFocusSchool.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'socioEconomicFocusOthers',
        label: 'models.address.socioEconomicFocusOthers.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'socioEconomicFocusComment',
        label: 'models.address.socioEconomicFocusComment.oew_name' | translate,
        width: '250px',
      },
      {
        key: 'socioEconomicFocusUntlw',
        label: 'models.address.socioEconomicFocusUntlw.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'addressClassificationForSchool',
        label:
          'models.address.addressClassificationForSchool.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'addressClassificationForHospital',
        label:
          'models.address.addressClassificationForHospital.oew_name'
          | translate,
        width: '120px',
      },
      {
        key: 'addressClassificationForDifficultarea',
        label:
          'models.address.addressClassificationForDifficultarea.oew_name'
          | translate,
        width: '120px',
      },
      {
        key: 'addressClassificationForCompanies',
        label:
          'models.address.addressClassificationForCompanies.oew_name'
          | translate,
        width: '120px',
      },
      {
        key: 'addressClassificationForEligibleCompanies',
        label:
          'models.address.addressClassificationForEligibleCompanies.oew_name'
          | translate,
        width: '140px',
      },
      {
        key: 'addressClassificationForSocioeconomicFocus',
        label:
          'models.address.addressClassificationForSocioeconomicFocus.oew_name'
          | translate,
        width: '150px',
      },
      {
        key: 'addressClassificationForPrivateHouseholds',
        label:
          'models.address.addressClassificationForPrivateHouseholds.oew_name'
          | translate,
        width: '140px',
      },
      {
        key: 'addressClassificationForPrivateSocioEconomicCompanies',
        label:
          'models.address.addressClassificationForPrivateSocioEconomicCompanies.oew_name'
          | translate,
        width: '180px',
      },
      {
        key: 'mevAlreadyFunded',
        label: 'models.address.mevAlreadyFunded.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'mevContradictionDate',
        label: 'models.address.mevContradictionDate.oew_name' | translate,
        width: '120px',
        cellTemplate: dateCellTemplate,
      },
      {
        key: 'addressRequest',
        label: 'models.address.addressRequest.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'addressRequestComment',
        label: 'models.address.addressRequestComment.oew_name' | translate,
        width: '250px',
      },
      {
        key: 'underSuppliedConnection',
        label: 'models.address.underSuppliedConnection.oew_name' | translate,
        width: '120px',
      },
      {
        key: 'underSuppliedConnectionComment',
        label:
          'models.address.underSuppliedConnectionComment.oew_name' | translate,
        width: '300px',
      },
    ] | mergeColumns: extraColumns
  "
  [tableData]="tableData"
  [total]="total"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [isLoading]="isLoading"
  [defaultSorting]="defaultSorting"
  [customNoResultText]="'components.masterAddresses.noResultText' | translate"
  (changeHandler)="changeHandler.emit($event)"
/>

<ng-template #dateCellTemplate let-item="item">
  {{ item | date: 'dd.MM.yyyy - HH:mm:ss' }}
</ng-template>

<ng-template #markedCellTemplate let-item="item">
  <div [innerHTML]="item | highLightText: sword"></div>
</ng-template>
